import { render, staticRenderFns } from "./MapBuildingsToggler.vue?vue&type=template&id=08b83072"
import script from "./MapBuildingsToggler.vue?vue&type=script&lang=js"
export * from "./MapBuildingsToggler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports